import { useParams } from 'react-router';
import { apiClient } from '@src/api/client';
import { useImpersonate } from '@src/contexts/ImpersonateContext';

export const useSample = () => {
  const { id } = useParams<{ id: string }>();
  const { isImpersonating } = useImpersonate();

  if (!id) {
    return { data: undefined, isLoading: false };
  }
  return apiClient.useQuery(
    'get',
    '/api/sample/{sampleId}',
    {
      params: {
        path: { sampleId: id! },
        query: isImpersonating ? { isImpersonating: 'true' } : undefined,
      },
    },
    { throwOnError: true },
  );
};
